import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TableStateService {
  private scrollPosition = 0;
  private shouldRestore = false;

  setScrollPosition(position: number) {
    this.scrollPosition = position;
    this.shouldRestore = false;
  }

  enableRestore() {
    this.shouldRestore = true;
  }

  shouldRestoreScroll(): boolean {
    return this.shouldRestore;
  }

  resetRestoreFlag() {
    this.shouldRestore = false;
  }

  getScrollPosition(): number {
    return this.scrollPosition;
  }
}